import React from "react";
import EditorButton from "./components/EditorButton";
import Divider from "./components/Divider";
import TextOptions from "./module/TextOptions";
import ImageAndLink from "./module/ImageAndLink";
import TextAlignOptions from "./module/TextAlignOptions";
import FontFamilySelector from "./module/FontFamilySelector";

const Toolbar = ({
  editor,
  fontFamilies = [],
  imageUploadApi,
  uploadApiMethod,
}) => {
  return (
    <div className="flex flex-wrap gap-2 justify-center pb-2 px-3">
      {/* Undo/Redo */}
      <EditorButton
        onClick={() => editor.chain().focus().undo().run()}
        className={!editor.can().undo() ? "opacity-30" : "opacity-100"}
        title="Undo"
      >
        <i className="format undo"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().redo().run()}
        className={!editor.can().redo() ? "opacity-30" : "opacity-100"}
        title="Redo"
      >
        <i className="format redo"></i>
      </EditorButton>
      <Divider />
      <div className="gap-2 flex flex-wrap items-center justify-center">
        <TextOptions editor={editor} />
        <FontFamilySelector editor={editor} fontFamilies={fontFamilies} />
      </div>
      <Divider />
      {/* Basic Formatting */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBold().run()}
        isActive={editor.isActive("bold")}
        title="Bold"
      >
        <i className="format bold"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleItalic().run()}
        isActive={editor.isActive("italic")}
        title="Italic"
      >
        <i className="format italic"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        isActive={editor.isActive("underline")}
        title="Underline"
      >
        <i className="format underline"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleStrike().run()}
        isActive={editor.isActive("strike")}
        title="Strike"
      >
        <i className="format strikethrough"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleCode().run()}
        isActive={editor.isActive("code")}
        title="Code"
      >
        <i className="format code"></i>
      </EditorButton>
      <Divider />
      <ImageAndLink
        editor={editor}
        imageUploadApi={imageUploadApi}
        uploadApiMethod={uploadApiMethod}
      />
      <Divider />
      {/* Lists */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        isActive={editor.isActive("bulletList")}
        title="Bullet List"
      >
        <i className="format list-ul"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        isActive={editor.isActive("orderedList")}
        title="Ordered List"
      >
        <i className="format list-ol"></i>
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleTaskList().run()}
        isActive={editor.isActive("taskList")}
        title="Task List"
      >
        <i className="format tasks-list"></i>
      </EditorButton>
      <Divider />

      {/* Block Elements */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        isActive={editor.isActive("blockquote")}
        title="Blockquote"
      >
        <i className="format quote-right"></i>
      </EditorButton>
      <Divider />
      <EditorButton
        onClick={() => editor.chain().focus().setHorizontalRule().run()}
        title="Horizontal Rule"
      >
        <i className="format horizontal-rule"></i>
      </EditorButton>
      <Divider />
      <TextAlignOptions editor={editor} />
    </div>
  );
};

export default Toolbar;
